export const formatCap = bytes => (bytes >= 1024 ** 3 ? `${Math.round(bytes / 1024 ** 3)} GB` : `${Math.round(bytes / 1024 ** 2)} MB`)

function isOffice(file, office) {
  if (!office) return false
  const ext = /(\.[^.]+)$/.exec(file?.name ?? '')?.[1]?.toLowerCase() ?? ''
  const type = String(file?.type ?? '')
    .split(';')[0]
    .trim()
    .toLowerCase()
  return (office.extensions ?? []).includes(ext) || (office.mimeTypes ?? []).includes(type)
}

export function capFor(file, limits) {
  if (!limits?.maxBytes) return null
  return isOffice(file, limits.office) ? Math.min(limits.office.maxBytes, limits.maxBytes) : limits.maxBytes
}

export function capNote(limits) {
  if (!limits?.maxBytes) return ''
  const office = limits.office?.maxBytes
  return office && office < limits.maxBytes
    ? ` Up to ${formatCap(limits.maxBytes)} per file; ${formatCap(office)} for office documents.`
    : ` Up to ${formatCap(limits.maxBytes)} per file.`
}
